module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-04.42045ef8.png";